import { Scene } from "phaser";
import { GButton } from "../gameobjects/GButton";
import { ExpandingCircle } from "../gameobjects/ExpandingCircle";

import { formatNumberWithCommas, padNumber, truncateString, updateRegistry, getBalance } from "../utils";

// The HUD scene is the scene that shows the points and the remaining time.
export class HudScene extends Scene {
    
    remaining_time = 0;

    remaining_time_text;
    points_text;

    constructor() {
        super("HudScene");
        this.retryAttempts = 0;  // Track retry attempts
        this.maxRetries = 5;     // Optional: Limit retries
        this.retryDelay = 5000;  // Retry delay in milliseconds (5 seconds)
        
    }

    init(data) {
        this.cameras.main.fadeIn(500, 0, 0, 0);
    }

    create() {

        const HudButtonSizeX = 40;
        // const UserNameStyle = { fontSize: 26, fontFamily: 'Oswald', color: '#fff', fontWeight:700 };
        // const BalanceStyle = { fontSize: 24, fontFamily: 'Oswald', color: '#fff', fontWeight:500,  lineSpacing: 10};


        var hudConfig = {
            playerProfileScale: 1,
            playerProfileImage: {
                x:  64,
                y: 64,
            },
            UserNameStyle: { fontSize: '26px', fontFamily: 'Oswald', color: '#fff', fontWeight:700 },
            UserName: { x: 64*2, y: 30, scale: 1},
            BalanceStyle: { fontSize: '24px', fontFamily: 'Oswald', color: '#fff', fontWeight:500,  lineSpacing: 10},
            Balance: { x: 64*2, y: 66},
            historyButton: {
                scale: 1,
                x: this.scale.width - (HudButtonSizeX/2 + 16) *2,
                y: 60,
            },
            infoButton: {
                scale: 1,
                x: this.scale.width - (HudButtonSizeX*2 + 10) *2,
                y: 60,
            },
        }

        if (!window.isMobile) {
            hudConfig = {
                playerProfileScale: 0.5,
                playerProfileImage: {
                    x:  32,
                    y:  32,
                },
                UserNameStyle: { fontSize: '56px', fontFamily: 'Oswald', color: '#fff' },
                UserName: { x: 64, y: 15, scale: 0.25},
                BalanceStyle: { fontSize: '24px', fontFamily: 'Oswald', color: '#fff', fontWeight:500},
                Balance: { x: 64, y: 34, scale: 0.5},
                historyButton: {
                    scale: 0.5,
                    x: this.scale.width - (HudButtonSizeX/2+10),
                    y: 30,
                },
                infoButton: {
                    scale: 0.5,
                    x: this.scale.width - (HudButtonSizeX*2),
                    y: 30,
                },
            }
        }

        this.registry.events.on('changedata', updateRegistry);

        // Listen for the 'update-text' event from Scene B
        this.game.events.on('update-balance', this.updateBalance, this);
         // Retrieve parameters from localStorage
         const storedParamsJSON = localStorage.getItem('gameParams');
         const storedParams = JSON.parse(storedParamsJSON) || {};
 
         const token = storedParams['token'] || '';
         const brand = storedParams['brand'] || '';

         this.registry.set('brand', brand);
         this.registry.set('token', token);


        const playerProfile = this.add.sprite(0, 0, 'pack', 'Header 1 - BG.png').setOrigin(0);
        playerProfile.setScale(hudConfig.playerProfileScale);
        
        
        const playerProfileImage = this.add.image(hudConfig.playerProfileImage.x, hudConfig.playerProfileImage.y, 'player-profile-image').setOrigin(0.5).setDisplaySize(64,64);
        playerProfileImage.setScale(hudConfig.playerProfileScale);
        
       

        const UserName = this.registry.get('username');
        this.userNameText = this.add.text(hudConfig.UserName.x, hudConfig.UserName.y, truncateString(UserName, 10),  hudConfig.UserNameStyle);
        this.userNameText.setFontStyle("700");
        this.userNameText.setScale(hudConfig.UserName.scale)

        this.balanceText = this.add.text(hudConfig.Balance.x, hudConfig.Balance.y, `-`, hudConfig.BalanceStyle).setOrigin(0,0);
        console.log("hudConfig.BalanceStyle", hudConfig.BalanceStyle);
        this.balanceText.setScale(hudConfig.Balance.scale)
        this.balanceText.setLetterSpacing(2)


        const ButtonHistory = new GButton(this, hudConfig.historyButton.x, hudConfig.historyButton.y, {
            texturePack: "pack", 
            idleTexture: 'Header 1 - Button BG - Default.png',
            hoverTexture: 'Header 1 - Button BG - Default.png',
            clickedTexture: 'Header 1 - Button BG - Clicked.png',
            disabledTexture: 'Header 1 - Button BG - Default.png',
            // text: 'Click Me',
            icon: {
                image: 'history-icon.png',
                scale: 0.6
            },
            onClick: () => {
                //console.log('Button ButtonHistory!');
                // this.scene.stop("MenuScene")
                // this.scene.stop("TimerScene")
                // this.scene.stop("InfoScene")
                if(window.isMobile){
                    this.scene.launch("HistoryScene")
                }else{
                    this.scene.launch("HistorySceneDesktop")
                }
            }
        });
        
        ButtonHistory.setScale(hudConfig.historyButton.scale)


        const ButtonInfo = new GButton(this, hudConfig.infoButton.x, hudConfig.infoButton.y, {
            texturePack: "pack", 
            idleTexture: 'Header 1 - Button BG - Default.png',
            hoverTexture: 'Header 1 - Button BG - Default.png',
            clickedTexture: 'Header 1 - Button BG - Clicked.png',
            disabledTexture: 'Header 1 - Button BG - Default.png',
            // text: 'Click Me',
            icon: {
                image: 'info-icon.png',
                scale: 0.6
            },
            onClick: () => {
                //console.log('Button InfoScene!');
                // this.scene.stop("MenuScene")
                // this.scene.stop("TimerScene")
                // this.scene.stop("HistoryScene")
                if(window.isMobile){
                    this.scene.launch("DetailsScene")
                }else{
                    this.scene.launch("DetailsSceneDesktop")
                }
                
            }
        });
        
        ButtonInfo.setScale(hudConfig.infoButton.scale)

        if (window.isMobile) {
            this.input.on('pointerdown', (pointer) => {
                // Create a new ExpandingCircle at the pointer's position
                new ExpandingCircle(this, pointer.x, pointer.y);
            });
        }

        this.fetchAndUpdateBalance();

          // Set up interval to update balance every 10 seconds
        this.time.addEvent({
            delay: 10000,
            callback: this.fetchAndUpdateBalance,
            callbackScope: this,
            loop: true
        });


         // Start fetching balance stream
         //this.fetchBalanceStream();
         //console.log("this.fetchBalanceStream(token, brand);",token, brand )

    }

    update() {
        //this.fps.setText(this.game.renderer.getFps());
    }

    updateBalance(newbalance){

        //console.log("newbalance",newbalance)
        this.updateBalanceUI(newbalance)

    }

    async fetchAndUpdateBalance() {
        //console.log("fetchAndUpdateBalance");
        try {
            const balanceData = await getBalance();

            //console.log("balanceData", balanceData);
            if (balanceData.error == null) {
                const {  balance, username } = balanceData.balanceData;
                this.data.set('walletBallance', balance);
                this.registry.set('walletBallance', balance);
                this.data.set('title', username);
                
                this.updateBalance(balance);
                this.updateTitle(username);
            } else {
                //this.scene.stop('MainMenu');
                //this.scene.start('ErrorScene', balanceData.error);
                console.error('Failed to fetch balance',  balanceData.error);
            }
        } catch (error) {
            console.error('_Failed to fetch balance:', error);
        }

    }

     // Async function to fetch and process the balance stream
     async fetchBalanceStream() {
        try {
            const base_url = `${import.meta.env.VITE_BACKEND_BASE_URL}:${import.meta.env.VITE_BACKEND_PORT}`;
           
            const response = await fetch(`${base_url}/api/v1/players/sync-balance`, {
                method: 'GET',
                headers: {
                    'X-GA-ClientId': this.registry.get('brand'), // Add the X-GA-ClientId header
                    'X-GA-Authentication-Token': this.registry.get('token'), // Add the X-GA-ClientSecret header
                    //'Content-Type': 'application/octet-stream', // Optional, depends on the server setup
                },
                 mode: 'cors'
            });

           

            // Get a reader from the response body
            const reader = response.body.getReader();

            const processChunk = async () => {
                //console.log("response", response)
                const { done, value } = await reader.read();
                if (done) {
                    console.log("Stream ended. Attempting to reconnect...");
                    this.retryConnection();
                    return;
                }

                // Convert ArrayBuffer to Float64 (for balance)
                const dataView = new DataView(value.buffer);
                const balance = dataView.getFloat64(0, true); // Assuming little-endian
                this.registry.set('my-balance', balance);
                // Update the balance on the game UI
                this.updateBalanceUI(balance);

                // Continue reading the next chunk
                processChunk();
            };

            
            // Reset retry attempts on successful connection
            this.retryAttempts = 0;

            // Start processing the stream
            processChunk();
        } catch (error) {
            console.error("Error receiving balance stream:", error);
            this.retryConnection();
        }
    }

    // Retry connection after a delay
    retryConnection() {
        if (this.retryAttempts < this.maxRetries) {
            this.retryAttempts++;
            console.log(`Retrying connection in ${this.retryDelay / 1000} seconds... (Attempt ${this.retryAttempts})`);

            setTimeout(() => {
                //this.fetchBalanceStream();

            }, this.retryDelay);
        } else {
            console.error("Max retry attempts reached. Could not reconnect to the stream.");
        }
    }

    // Method to update the balance text in the game
    updateBalanceUI(balance) {
        this.balanceText.setText('$' + formatNumberWithCommas(balance));
        //this.balanceText.setLetterSpacing(2)
    }

    updateBalance(balance) {
        this.balanceText.setText('$' + formatNumberWithCommas(balance));
        //this.balanceText.setLetterSpacing(0)
    }

    updateTitle(username) {
        this.userNameText.setText(this.truncateText(username));
    }

    truncateText(text) {
        if (text.length > 9) {
            return text.slice(0, 9) + '...';
        }
        return text;
    }

  
}